export default {
    methods: {
        // Afficher des messages à l'utilisateur
        alert(element, customStatut){
          console.log(element) //C'est toujours utile, surtout quand j'ai une erreur indéfinie
          if (typeof(element) == "string"){
            //Si mon élément est une simple chaine de caractères, je la renvoie telle qu'elle
            this.$store.state.alert.message = element
            this.$store.state.alert.status  = customStatut
            this.$store.state.alert.date    = Date.now()
          } else if(element.data && element.data.message){
            //La structure de l'élément correspond à celle d'une réponse de requête
            this.$store.state.alert.message = element.data.message
            this.$store.state.alert.status  = element.status
            this.$store.state.alert.date    = Date.now()
          } else if (element.response && element.response.data && element.response.data.message){
            //La structure de l'élément correspond à celle d'une erreur de requète
            this.$store.state.alert.message = element.response.data.message
            this.$store.state.alert.status  = element.response.status
            this.$store.state.alert.date    = Date.now()
          } else {
            // //L'élément ne correspond à rien de connu
            // this.$store.state.alert.message = "Erreur.."
            // this.$store.state.alert.status  = 0
            // this.$store.state.alert.date    = Date.now()
          }
        },

        // Vérifier si l'user en cours à le droit de faire cette action sur cette ressource
        can(action, ressource){    
            if (this.$store.state.auth.currentPerm[ressource] && this.$store.state.auth.currentPerm[ressource][action]){
                return true
              } else {
                return false
              }
        },
        
        // Passer toute une string en lettres capitales
        capitalize(string){
          if(typeof string === 'string') {
              return string.replace(/^\w/, str => str.toUpperCase());
          } else {
              return '';
          }
        },

        // Pour comparer deux objets. Renvoie la liste des différences
        compare(originalObject, mirrorObject){
          let differences = []
          
          //pour chaque propriété de l'objet...
          for (const prop in mirrorObject) {
            //Je regarde s'il y a des différences et je gomme les différences entre falsy
            if (mirrorObject[prop] != originalObject[prop] && !((mirrorObject[prop] == undefined || mirrorObject[prop] == null || mirrorObject[prop] == "") && (originalObject[prop] == undefined || originalObject[prop] == null || originalObject[prop] == ""))){
              let item = {
                prop      : prop,
                original  : originalObject[prop],
                mirror    : mirrorObject[prop]
              }
              differences.push(item)
            }
          }

          return differences
        },
    }
}